<script>
    import { onMount } from 'svelte';
    import { cookieConsent } from '../../store/cookieStore.js';

    let showBanner = false;

    onMount(() => {
        const consent = $cookieConsent;
        if (consent === 'true') {
            loadGoogleAnalytics();
        } else if (consent !== 'false') {
            showBanner = true;
        }

        cookieConsent.subscribe(value => {
            if (value === 'true') {
                loadGoogleAnalytics();
                showBanner = false;
            } else if (value === 'false') {
                showBanner = false;
            } else {
                showBanner = true;
            }
        });
    });

    function acceptCookies() {
        cookieConsent.set('true');
    }

    function declineCookies() {
        cookieConsent.set('false');
    }

    function loadGoogleAnalytics() {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-6VE6SK2BGW';
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-6VE6SK2BGW');
    }
  </script>
  
  {#if showBanner}
    <div class="cookie-banner">
      <p>Vi använder cookies för att samla in anonym statistik som hjälper oss att förbättra din upplevelse. Läs mer i vår <a href="/legal">integritetspolicy</a>. Godkänner du vår användning av cookies?</p>
      <div class="buttons">
        <button class="accept" on:click={acceptCookies}>Acceptera</button>
        <button class="decline" on:click={declineCookies}>Avböj</button>
      </div>
    </div>
  {/if}
  
  <style>
    .cookie-banner {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      min-height: 50px;
      background: #333;
      color: white;
      padding: 1rem;
      text-align: center;
      z-index: 100000;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .cookie-banner a {
      color: #bbbbbb;
      text-decoration: underline;
    }
    .cookie-banner p {
      margin: 0;
      margin-right: 1rem;
    }
    .buttons button {
      padding: 10px 20px;
      border: 1px solid transparent;
      border-radius: 8px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.2s ease-in-out;
      display: inline-block;
      font-size: 0.9rem;
      margin: 4px 2px;
    }

    .buttons .accept {
      background-color: var(--hover);
      color: white;
      box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
    }

    .buttons .accept:hover {
      background-color: var(--hover);
		  transform: translateY(-2px);
      box-shadow: 0 6px 20px 0 rgba(0, 118, 255, 0.23);
    }

    .buttons .accept:active {
      transform: translateY(0);
    }
    
    .buttons .decline {
      background-color: transparent;
      color: #bbbbbb;
      font-weight: normal;
    }

    .buttons .decline:hover {
      color: white;
      text-decoration: underline;
    }
  </style>